module.exports = __webpack_public_path__ + "img/logo.494d25b3.png";